import React from 'react';
import { Linkedin, Mail, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import Logo from './Logo';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    Company: [
      { label: 'About', href: '/about' },
      { label: 'Case Studies', href: '/case-studies' },
      { label: 'Careers', href: '/about' },
    ],
    Services: [
      { label: 'Product Development', href: '/services/product-development' },
      { label: 'AI Solutions', href: '/services/ai-solutions' },
      { label: 'Staff Augmentation', href: '/services/staff-augmentation' },
    ],
    Industries: [
      { label: 'Real Estate', href: '/industries/real-estate' },
      { label: 'Fintech', href: '/industries/fintech' },
      { label: 'Wealth Management', href: '/industries/wealth-management' },
      { label: 'Investment Banking', href: '/industries/investment-banking' },
    ],
  };

  return (
    <footer className="bg-white border-t border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-10 lg:gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Logo className="mb-5" />
            <p className="text-slate-500 mb-6 max-w-sm text-sm leading-relaxed">
              We help ambitious companies build their digital products — from AI-powered platforms
              to full-stack engineering. Working with startups and enterprises worldwide.
            </p>
            <div className="flex space-x-3">
              <a
                href="https://www.linkedin.com/company/cliktechnologies"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Follow Clik Technologies on LinkedIn"
                className="w-10 h-10 rounded-lg bg-slate-50 flex items-center justify-center text-slate-400 hover:text-[#2693FF] hover:bg-blue-50 transition-all duration-200 cursor-pointer"
              >
                <Linkedin size={18} />
              </a>
              <a
                href="mailto:hello@cliktechnologies.com"
                aria-label="Email Clik Technologies"
                className="w-10 h-10 rounded-lg bg-slate-50 flex items-center justify-center text-slate-400 hover:text-[#2693FF] hover:bg-blue-50 transition-all duration-200 cursor-pointer"
              >
                <Mail size={18} />
              </a>
            </div>
          </div>

          {/* Link columns */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h3 className="font-heading font-semibold text-slate-900 mb-4 text-sm">{category}</h3>
              <ul className="space-y-3">
                {links.map((link, index) => (
                  <li key={index}>
                    <Link to={link.href} className="text-slate-500 hover:text-slate-900 transition-colors text-sm">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* CTA column */}
          <div>
            <h3 className="font-heading font-semibold text-slate-900 mb-4 text-sm">Get Started</h3>
            <p className="text-slate-500 text-sm mb-4 leading-relaxed">
              Ready to discuss your project?
            </p>
            <a
              href="https://calendar.app.google/MfHsR1LurH5q2Rii7"
              target="_blank"
              rel="noopener noreferrer"
              className="group inline-flex items-center gap-1.5 text-sm font-semibold transition-colors"
              style={{ color: '#2693FF' }}
            >
              Schedule a call
              <ArrowRight className="w-3.5 h-3.5 group-hover:translate-x-1 transition-transform" />
            </a>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="pt-8 border-t border-slate-100">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-center sm:text-left">
            <p className="text-slate-400 text-xs">
              &copy; {currentYear} Clik Technologies. All rights reserved.
            </p>
            <div className="flex gap-6">
              <Link to="/privacy" className="text-slate-400 hover:text-slate-600 text-xs transition-colors">
                Privacy Policy
              </Link>
              <Link to="/terms" className="text-slate-400 hover:text-slate-600 text-xs transition-colors">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
